module.exports = __webpack_public_path__ + "img/route_3.a7c4ba8b.png";